<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div
            class="flex-card light-bordered light-raised has-margin-top-30"
            style="overflow: auto"
          >
            <div class="card-body">
              <ValidationObserver v-slot="{ passes }">
                <h2 class="title">{{ adding ? "Add" : "Edit" }} Dependant</h2>
                <form @submit.prevent="passes(submit)">
                  <div class="columns is-multiline">
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Firstname"
                          v-model="entry.firstname"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Surname"
                          v-model="entry.surname"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseDatePicker
                          label="Date of Birth"
                          rules="required"
                          v-model="entry.dob"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <GenderSelect
                          label="Gender"
                          v-model="entry.gender"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Gym Name"
                          v-model="entry.gymname"
                          rules="required"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="has-text-centered has-margin-top-30">
                    <div class="is-block has-text-centered">
                      <router-link
                        class="button btn-align no-lh raised is-medium has-margin-right-5"
                        :to="{ name: 'ManageDependants' }"
                      >
                        Back to Dependants
                      </router-link>
                      <button
                        class="button btn-align no-lh raised is-medium primary-btn"
                        type="submit"
                        :disabled="saving"
                        :class="{ 'is-loading': saving }"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/BaseInput";
import BaseDatePicker from "@/components/BaseDatePicker";
import GenderSelect from "@/components/GenderSelect";
import DependantApi from "@/api/dependant";
export default {
  components: {
    BaseInput,
    GenderSelect,
    BaseDatePicker,
  },
  data() {
    return {
      entry: {},
      saving: false,
      loading: true,
    };
  },
  created() {
    if (!this.adding) {
      DependantApi.getOne(this.$route.params.id).then((response) => {
        this.entry = response;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    adding() {
      return !this.$route.params.id;
    },
  },
  methods: {
    async submit() {
      this.saving = true;
      try {
        await DependantApi.save(this.entry);
        this.$buefy.toast.open({
          message: "Dependant saved successfully!",
          position: "is-top",
          type: "is-success",
        });
        this.$router.push({ name: "ManageDependants" });
      } catch (error) {
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error saving your dependant.",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>